import React from "react";
import loginIng from './static/login.svg';
import forgotIng from './static/forgot-img.svg';
import registrationImg from './static/registration-img.svg';
import confirmation from './static/confirmation.svg'
import { useLocation } from "react-router-dom";
import path from "../../routes/path";

const AuthImage = () => {
    const location = useLocation().pathname
    console.log(location)
    const authImg = () => {
        if (location === path.registration || location === path.ragistration_dy) {
            return <div className="auth-image"><img src={registrationImg} alt="" /></div>
        } else if (location === path.login) {
            return <div className="auth-image"><img src={loginIng} alt="" /></div>;
        } else if (location === path.forget_password || location === path.forget_password_confirm) {
            return <div className="auth-image"><img src={forgotIng} alt="" /></div>;
        } else if (location === path.registration_confirmation || location === path.registration_phone_confirmation || location === path.forget_password_mobile_confirm) {
            return <div className="auth-image"><img src={confirmation} alt="" /></div>;
        } else if (location === path.reset_password || location === path.confirm_signup) {
            return <div className="auth-image"><img src={registrationImg} alt="" /></div>;
        } 
    }


    return(
       authImg()
    )
}
export default AuthImage;